import { Chart } from '@repo/shared/dtos/assistant'
import { ChartOptions } from 'chart.js'

import { SimpleChartOptions as SimpleChartOptions } from '../common/ChartComponent'

export function getEnhancedOptions(
  chart: Chart,
  options: SimpleChartOptions,
): ChartOptions<'pie'> | ChartOptions<'bar'> {
  const textColor = 'rgb(18 71 66)' // 'oklch(87.2% 0.01 258.338)' // text-gray-300
  if (chart.type === 'pie') {
    return {
      ...options,
      color: textColor,
      plugins: {
        ...options.plugins,
        legend: { labels: { color: textColor } },
      },
    } satisfies ChartOptions<'pie'>
  } else if (chart.type === 'bar' || chart.type === 'line') {
    return {
      ...options,
      plugins: {
        ...options.plugins,
        legend: { labels: { color: textColor } },
      },
      scales: {
        x: { ticks: { color: textColor } },
        y: { ticks: { color: textColor } },
      },
    } satisfies ChartOptions<'bar'>
  }
  return options
}
